const styles = theme => ({
    root: {
        //marginBottom: theme.spacing(4),
    },
    contentContainer: {
        marginBottom: theme.spacing(2),
    },
    fullWidth: {
        width: '100%',
    },
    container: {
        width: '100%',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(4),
    },
    body: {
        marginBottom: theme.spacing(2),
    },
    warning: {
        color: theme.palette.error.main
    },
    row: {
        marginBottom: theme.spacing(1)
    }
});

export default styles;